import { render, staticRenderFns } from "./course-equivalents.vue?vue&type=template&id=2babcdec&"
import script from "./course-equivalents.vue?vue&type=script&lang=js&"
export * from "./course-equivalents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports